var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('nav',{staticClass:"breadcrumb",attrs:{"aria-label":"Breadcrumb"}},[_c('a',{attrs:{"href":"/"}},[_vm._v("Home")]),_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("/")]),_c('span',[_vm._v(_vm._s(_vm.currentLabel))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }